import React from "react";
const LeftNavigation = ({
  children,
  mobile
}: {
  readonly children: React.ReactNode;
  readonly mobile?: boolean;
}) => {
  return <div aria-label="left-navigation" className={`${mobile ? "left-navigation-mobile" : "space-y-3 left-navigation"} 
                `}>
            {children}
        </div>;
};
export default LeftNavigation;